import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Linkedin, Facebook, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../mock';

const Footer = () => {
  const navigation = {
    produk: [
      { name: 'GPU Monitoring', href: '/products' },
      { name: 'Kubernetes', href: '/products' },
      { name: 'Application', href: '/products' },
      { name: 'Database', href: '/products' },
      { name: 'Server', href: '/products' },
    ],
    perusahaan: [
      { name: 'Tentang Kami', href: '/about' },
      { name: 'Pelanggan', href: '/customers' },
      { name: 'Karir', href: '#' },
      { name: 'Blog', href: '#' },
    ],
    dukungan: [
      { name: 'Dokumentasi', href: '#' },
      { name: 'Kontak', href: '/contact' },
      { name: 'FAQ', href: '#' },
      { name: 'Status', href: '#' },
    ],
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="container mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <motion.img
                src="/vamos-logo.png"
                alt="Vamos Digital Solusi"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
                className="h-24 w-auto"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Partner resmi WhaTap di Indonesia. Platform observability AI-native untuk monitoring GPU, aplikasi, Kubernetes, server, dan database dalam satu platform terpadu.
            </p>
            
            {/* Contact info */}
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-slate-400">
                <Mail className="w-5 h-5 text-emerald-400" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-emerald-400 transition-colors">
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span>{contactInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Produk */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Produk</h3>
            <ul className="space-y-3">
              {navigation.produk.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-slate-400 hover:text-emerald-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Perusahaan */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Perusahaan</h3>
            <ul className="space-y-3">
              {navigation.perusahaan.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-slate-400 hover:text-emerald-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Dukungan */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Dukungan</h3>
            <ul className="space-y-3">
              {navigation.dukungan.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-slate-400 hover:text-emerald-400 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Vamos Digital Solusi - Partner Resmi WhaTap Indonesia. All rights reserved.
            </p>
            
            {/* Social links */}
            <div className="flex items-center gap-4">
              <motion.a
                href={contactInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-400 hover:text-emerald-400 hover:bg-slate-700 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </motion.a>
              <motion.a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-400 hover:text-emerald-400 hover:bg-slate-700 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </motion.a>
              <motion.a
                href={contactInfo.social.youtube}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -2 }}
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-400 hover:text-emerald-400 hover:bg-slate-700 transition-colors"
              >
                <Youtube className="w-5 h-5" />
              </motion.a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
